import { getPlaymakerMetadata } from 'lib/playmaker';

const isTeasePlaymakerOverride = (
  teaseIndex,
  layoutType,
  metadata,
) => {
  if (teaseIndex === 0) {
    const {
      playmakerSlot,
      playmakerToggle,
    } = getPlaymakerMetadata(metadata);

    if (playmakerToggle) {
      return (
        (layoutType === 'feature' && playmakerSlot === 0)
        || (layoutType === 'default' && playmakerSlot === 1)
        || (layoutType === 'liveBlog' && playmakerSlot === 2)
      );
    }
  }
  return false;
};

export {
  isTeasePlaymakerOverride,
};
